import React, { Component } from 'react'

import withCssClassName from '../with-css-class-name'

class TemplateIcon extends Component {
    render() {
        return (
            <svg {...this.props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 16"><path d="M17.6 4.9H.4V0h17.2v4.9zm-16-1.2h14.7V1.3H1.6v2.4zM7.8 16H.4V3.7h7.4V16zm-6.2-1.2h4.9V4.9H1.6v9.9zm16 1.2H6.5V3.7h11.1V16zm-9.8-1.2h8.6V4.9H7.8v9.9z" fill="#b9c2c5"/></svg>
        )
    }
}

export default withCssClassName(TemplateIcon)



// WEBPACK FOOTER //
// src/components/svg-icon/icons/template-icon.js